import { render, staticRenderFns } from "./detailLeads.vue?vue&type=template&id=79c610e4&"
import script from "./detailLeads.vue?vue&type=script&lang=js&"
export * from "./detailLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports